//export const Url="https://mirx.com.ar/tienda/";
//export const Url="https://mirx.com.ar/gcroldan/";
//export const Url="https://mirx.com.ar/gcbeauty/";
export const Url = "https://mirx.com.ar/grupomonterrey/";
